<script>
  import { format } from 'svelte-i18n';
  import {
    Button,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Input,
    InputGroup,
    Tooltip
  } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { fields as availableFields } from '@client/stores/fields';

  /**
   * The name of the input, used for form submission.
   * @type {string}
   */
  export let name;

  /**
   * The initial value of the input.
   * @type {string}
   */
  export let value;

  /**
   * Callback function executed when editing is canceled.
   * @type {() => void}
   */
  export let onCancel = () => {};

  /**
   * Callback function executed when changes are saved.
   * @type {(newValue: import('./types').ValueOrField) => void}
   */
  export let onChange = (newValue) => {};

  /** @type {HTMLInputElement} */
  let input;

  /** @type {string} */
  let newValue;

  const save = () => {
    onChange(
      $availableFields.includes(newValue) // TODO should we include others from template?
        ? {
            field: newValue
          }
        : {
            value: newValue
          }
    );
  };

  const cancel = () => {
    value = name;
    onCancel();
  };

  $: if (input) {
    input.focus();
    input.select();
  }

  $: newValue = value;
</script>

<Dropdown>
  <InputGroup>
    <Input
      {...$$restProps}
      class="rounded-0 border-0 ps-4 small"
      bind:inner={input}
      bind:value={newValue}
      on:keydown={(e) => {
        if (e.key === 'Escape') {
          cancel();
        } else if (e.key === 'Enter') {
          save();
        }
      }}
    />
    <DropdownToggle id="{name}-field" class="py-1 px-2 border-0 rounded-0">
      <Icon name="menu" />
    </DropdownToggle>
    <Tooltip target="{name}-field">{$format('label.FIELD_USE_ANOTHER')}</Tooltip>
    <Button id="{name}-save" class="p-1 border-0 rounded-0 text-success" on:click={save}>
      <Icon name="check" />
    </Button>
    <Tooltip target="{name}-save">{$format('label.SAVE')}</Tooltip>
    <Button id="{name}-cancel" class="p-1 border-0 rounded-0 text-danger" on:click={cancel}>
      <Icon name="x" />
    </Button>
    <Tooltip target="{name}-cancel">{$format('label.CANCEL')}</Tooltip>
  </InputGroup>
  <DropdownMenu style="max-height: 20rem; overflow-y: auto;">
    {#each $availableFields as field}
      <DropdownItem active={newValue === field} class="py-2 px-3" on:click={() => (newValue = field)}>
        <small>
          {field}
        </small>
      </DropdownItem>
    {/each}
  </DropdownMenu>
</Dropdown>
